import React,{createContext, useState} from 'react';

export const SoundContext = createContext();

export const SoundProvider = ({children}) =>{
    const [isSoundOn, setIsSoundOn] = useState(true);

    const toggleSound = () => {
        setIsSoundOn(prevIsSoundOn => !prevIsSoundOn);
    };

    return(
        <SoundContext.Provider value = {{isSoundOn, toggleSound}}>
            {children}
        </SoundContext.Provider>
    );
};